import script from "./Logistics.vue?vue&type=script&setup=true&lang=js"
export * from "./Logistics.vue?vue&type=script&setup=true&lang=js"

import "./Logistics.vue?vue&type=style&index=0&id=115ea54e&lang=less&scoped=true"

import exportComponent from "D:\\allcodes\\com\\qlt-v2\\web\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115ea54e"]])

export default __exports__